import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { showDialog } from "@widgets/CommonDialog";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnResizeBar from "@shared/components/SnResizeBar";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_MOW_REG_003_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
      grid2: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    const searchRef = useRef<any>(null);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let isSame: boolean = false;
        const checkedRows = getGridCurrent("grid1").getCheckedRows();
        if (checkedRows.length <= 1) return true;

        const cdWh = checkedRows[0].cd_wh; // 출고창고

        isSame = checkedRows.every((item: any) => item.cd_wh === cdWh);

        if (!isSame) {
          await showDialog("alter", "출고창고가 동일한 건만 적용 가능합니다.");
          return false;
        } else {
          return true;
        }
      },
      getOkayData: () => {
        return {
          rtnData: [
            getGridCurrent("grid1").getCheckedRows(),
            getGridCurrent("grid2").getCheckedRows(),
          ],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_MOW_REG_003_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mtl_mow_reg_003_pop_001_01",
          params: searchRef.current.getFormdata(),
        };
        getGridCurrent("grid1").resetUpdate();

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
        });
      } catch (error: any) {}
    };

    const onCheckedRowChagedH = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid2").setCheckedAll(value);
      } else {
        getGridCurrent("grid2").setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChagedL = (value: boolean) => {
      const checkedRows = getGridCurrent("grid2").getCheckedFilteredRows();
      if (checkedRows.length > 0)
        getGridCurrent("grid1").setCheckedFocusedRow(true, "noEvent");
      else getGridCurrent("grid1").setCheckedFocusedRow(false, "noEvent");
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCheckedRowChaged: onCheckedRowChagedH,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChagedL,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div
            style={{
              height: "55vh",
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <SnResizeBar direction={"height"} id="panel1" orgSize="40%">
              <SnGrid
                ref={gridRefs.current["grid1"]}
                columnConfig={grids.grid1.columns}
                rowData={grids.grid1.dataSource}
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                  ischeckboxSelection: true,
                }}
                events={grids.grid1.events}
                filter={{
                  refs: [gridRefs.current["grid2"]],
                  columns: ["no_io"],
                }}
              />
            </SnResizeBar>
            <SnResizeBar direction={"height"} id="panel2" orgSize="60%">
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                  ischeckboxSelection: true,
                }}
                events={grids.grid2.events}
              />
            </SnResizeBar>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_MOW_REG_003_POP_001;
